(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-footer"]) return;
  try {
    
(() => {
  const label = document.querySelector('[data-mp-price-label]')?.dataset.mpPriceLabel || '';
  const guard = () => document.querySelectorAll('product-card').forEach(card => {
    const price = card.querySelector('product-price .price');
    if (!price) return;
    const digits = price.textContent.replace(/[^0-9]/g, '');
    card.dataset.sxUnpriced = String(digits !== '' && Number(digits) === 0);
    const priceElement = card.querySelector('product-price');
    if (priceElement) priceElement.dataset.mpPriceLabel = label;
  });
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('.mp-mega').forEach(menu => {
    let timer;
    menu.addEventListener('pointerenter', () => {
      if (!hoverQuery.matches) return;
      clearTimeout(timer); menu.open = true;
    });
    menu.addEventListener('pointerleave', () => {
      if (!hoverQuery.matches) return;
      timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 160);
    });
  });
  guard();
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(guard).observe(main, {childList: true, subtree: true});
  document.addEventListener('submit', event => {
    if (event.target.closest('product-card[data-sx-unpriced="true"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mp-mega[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.mp-mega[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soa-footer"]) return;
  try {
    
(() => {
  const groups = [...document.querySelectorAll('.soa-footer-links')];
  const mobile = matchMedia('(max-width:749px)');
  groups.forEach(group => group.querySelector('summary').addEventListener('click', event => { if (!mobile.matches) event.preventDefault(); }));
  const update = () => groups.forEach(group => {
    if (mobile.matches && group.contains(document.activeElement)) group.querySelector('summary').focus();
    group.open = !mobile.matches;
  });
  update();
  mobile.addEventListener('change', update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soa-product"]) return;
  try {
    
(() => {
  const page = document.querySelector('.soa-product-v2');
  if (!page) return;
  const form = page.querySelector('#soa-product-form');
  const quantity = form.querySelector('input[name="quantity"]');
  const syncQuantity = () => {
    page.querySelector('[data-sticky-quantity]').textContent = quantity.value || quantity.min || '1';
    const min = Number(quantity.min) || 1;
    const step = Number(quantity.step) || 1;
    const max = quantity.max === '' ? Infinity : Number(quantity.max);
    page.querySelector('[data-quantity-step="-1"]').disabled = Number(quantity.value) - step < min;
    page.querySelector('[data-quantity-step="1"]').disabled = Number(quantity.value) + step > max;
  };
  page.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
    if (!quantity.checkValidity()) quantity.value = quantity.min || '1';
    Number(button.dataset.quantityStep) > 0 ? quantity.stepUp() : quantity.stepDown();
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  quantity.addEventListener('input', syncQuantity);
  quantity.addEventListener('change', syncQuantity);
  form.querySelector('[data-variant-select]')?.addEventListener('change', () => queueMicrotask(syncQuantity));
  syncQuantity();
  const variants = JSON.parse(document.getElementById('soa-variants').textContent);
  const selected = variants.find(v => String(v.id) === form.elements.id.value);
  if (selected?.price > 0) {
    const price = (window.Shopify?.currency?.active || 'TRY') === 'TRY' ? `${Math.ceil(selected.price / 100)} TL` : new Intl.NumberFormat(document.documentElement.lang || 'tr', { style: 'currency', currency: window.Shopify.currency.active }).format(selected.price / 100);
    page.querySelectorAll('[data-product-price]').forEach(element => element.textContent = price);
  }
  page.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => {
    page.querySelectorAll('[data-gallery]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  const zoom = document.getElementById('soa-product-zoom');
  const trigger = page.querySelector('[data-product-zoom]');
  if (trigger && zoom) {
    trigger.hidden = false;
    trigger.addEventListener('click', () => {
      const main = page.querySelector('#soa-main-image');
      zoom.querySelector('img').src = main.src || main.currentSrc;
      zoom.showModal();
    });
    zoom.querySelector('[data-zoom-close]').addEventListener('click', () => zoom.close());
    zoom.addEventListener('close', () => trigger.focus({ preventScroll: true }));
  }
})();


  } catch(e) { console.error(e); }
})();
})();
